function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17 10h-7v7a1 1 0 01-2 0v-7H1a1 1 0 010-2h7V1a1 1 0 012 0v7h7a1 1 0 010 2z",
  fill: "#333"
});

var SvgPlusIcon = function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+Cgk8cGF0aAoJCWQ9Ik0xNyAxMGgtN3Y3YTEgMSAwIDAgMS0yIDB2LTdIMWExIDEgMCAwIDEgMC0yaDdWMWExIDEgMCAwIDEgMiAwdjdoN2ExIDEgMCAwIDEgMCAyeiIKCQlmaWxsPSIjMzMzIgoJCWZpbGxSdWxlPSJldmVub2RkIgoJLz4KPC9zdmc+Cg==";
export { SvgPlusIcon as ReactComponent };